export default "__VITE_ASSET__BfRy1kPT__"